<template>
  <div>
    <el-button @click="handleClick">设置价格锚点</el-button>
    <el-dialog
      :visible="dialog"
      class="sp-dialog"
      append-to-body
      destroy-on-close
      title="设置价格锚点"
      width="800px"
      @close="onCancel"
    >
      <div class="point-box">
        <div
          :class="{
            'point-box-left': true,
            'padded': padded
          }"
        >
          <div :class="{ 'point-box-bg': true }" :style="{ backgroundImage: `url(${bgImg})` }">
            <dragContainer v-model="valueData"></dragContainer>
          </div>
        </div>
        <div class="point-box-setting">
          <div class="title">设置价格锚点</div>
          <div style="margin-bottom: 10px;">
            <AttrGoods v-model="valueData"></AttrGoods>
          </div>
          <div>
            <AttrItem v-if="valueData[0].price" v-model="valueData"></AttrItem>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AttrItem from './attr-item.vue';
import dragContainer from './dragContainer.vue'
import AttrGoods from '../hm-showcase/attr-goods'
import { cloneDeep } from 'lodash'
export default {
    name: "PointItem",
    props: {
      value: {
        type: Array,
        require: true,
        default:() => []
      },
      bgImg: {
        type: String
      },
      padded: {
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'value',
      event: 'update'
    },
    components: {
      AttrItem,
      dragContainer,
      AttrGoods
    },
    data() {
      return {
        dialog: false,
        valueData: [],
      }
    },
    created() {
      this.valueData = cloneDeep(this.value)
    },
    methods: {
      onCancel() {
        this.dialog = false
      },
      handleClick() {
        this.dialog = true
      },
      onConfirm() {
        this.$emit('update', this.valueData)
        this.dialog = false
      }
    }
  }
</script>
<style scoped lang="scss">
.point-box {
  display: flex;
  .point-box-left {
    flex: 0 375px;
    width: 375px;
    height: 562px;
    &.padded {
      padding: 64px 56px;
    }
    .point-box-bg {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .point-box-setting {
    padding: 20px;
    .title{
      margin-bottom: 10px;
    }
  }
}
</style>
